import Icons from 'components/atoms/Icons';
import {
  FilterPanelType,
  LocationFilterOptionsType,
  ProviderFilterOptionsType,
  ProviderFilterPanelsType,
  SetActiveFilterPanelType,
} from 'components/types/FilterTypes';
import { ClinicalTrialsFilterOptionsType } from 'lib/clinical-trials/types';
import React, { useEffect, useRef, useState } from 'react';

type FilterAccordionBtnProps = {
  setActiveFilterPanel: SetActiveFilterPanelType;
  filterPanel: FilterPanelType;
  activeFilterPanel: string | undefined;
  selectedFilters: any;
  clearResults?: Function;
  setSortedOffices?: Function;
  sortOffices?: Function;
  setOfficesClosed?: Function;
  setSortedLanguages?: Function;
  sortLanguages?: Function;
  setLanguagesClosed?: Function;
  filters:
    | ProviderFilterOptionsType
    | LocationFilterOptionsType
    | ClinicalTrialsFilterOptionsType;
};

const FilterAccordionBtn = (props: FilterAccordionBtnProps) => {
  const {
    setActiveFilterPanel,
    filterPanel,
    activeFilterPanel,
    selectedFilters,
    clearResults,
    setSortedOffices,
    sortOffices,
    setSortedLanguages,
    sortLanguages,
    filters,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const lastOpenRef = useRef<string | undefined>(undefined);
  const prevOpenRef = useRef<string | undefined>(undefined);

  const handleValueChange = (newValue: string | null) => {
    setIsOpen(!isOpen);
    if (newValue && newValue !== activeFilterPanel) {
      prevOpenRef.current = activeFilterPanel;
    }

    setActiveFilterPanel(
      activeFilterPanel !== filterPanel.id ? filterPanel.id : ''
    );
  };

  useEffect(() => {
    clearResults && clearResults();
    lastOpenRef.current = activeFilterPanel;
  }, [activeFilterPanel]);

  useEffect(() => {
    setSortedOffices && sortOffices && setSortedOffices(sortOffices());
    setSortedLanguages && sortLanguages && setSortedLanguages(sortLanguages());
  }, [filters]);

  return (
    <div className="filter-accordion-btn">
      <div
        className="accordion-item"
        onClick={() => {
          handleValueChange(filterPanel.id);
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            setActiveFilterPanel(
              activeFilterPanel !== filterPanel.id ? filterPanel.id : ''
            );
          }
        }}
        tabIndex={0}
      >
        <p>
          {filterPanel.name == 'Specialty'
            ? 'Specialties & Clinical Areas of Focus'
            : filterPanel.name}
          {selectedFilters[filterPanel.id as ProviderFilterPanelsType]?.length >
            0 &&
            ` (${
              typeof selectedFilters[
                filterPanel.id as ProviderFilterPanelsType
              ] == 'string'
                ? 1
                : selectedFilters[filterPanel.id as ProviderFilterPanelsType]
                    .length
            })`}
          {filterPanel.label && (
            <span className="filter-label">{filterPanel.label}</span>
          )}
        </p>
        <Icons
          id="pld-chevron-down"
          className={filterPanel.active ? 'icon-up' : 'icon-down'}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export default FilterAccordionBtn;
